const ATLASSIAN_DOMAINS: string[] = [
	'.atlassian.com',
	'.atlassian.net',
	'.jira-dev.com',
	'.jira.com',
	'.atlassian-stg-fedm.net',
	'.atlassian-us-gov-mod.net',
	'.atlassian-us-gov-mod.com',
];

export const isCustomDomain = (hostname: string): boolean =>
	!ATLASSIAN_DOMAINS.some((domain) => hostname.endsWith(domain));

const isValidUrl = (urlString: unknown) => {
	if (typeof urlString !== 'string') {
		return false;
	}
	try {
		return Boolean(new URL(urlString));
	} catch (e) {
		return false;
	}
};

export const getHostnameFromUrl = (url: string): string =>
	isValidUrl(url) ? new URL(url)?.hostname : '';

const isUrlCustomDomain = (parentHost: string, url: string) => {
	const hostname = getHostnameFromUrl(url);

	return isCustomDomain(parentHost) || (hostname && isCustomDomain(hostname));
};

export const setHostnameForContent = (url: string, hostname?: string) => {
	const parentHost = window?.location?.href || '';
	const contentHost = hostname ?? getHostnameFromUrl(url);

	return isUrlCustomDomain(parentHost, url) ? getHostnameFromUrl(parentHost) : contentHost;
};
